import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/plantillas_proyectos/plantillas_proyectos';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.plantillas_proyectos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
